import { useNavigate } from "react-router-dom";
import "./Css/ExamCreateForm.css";
import { useState, useEffect } from "react";
import axios from "axios";
import API_BASE from "../config/api";


const CreateExam = () => {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [dropdowns, setDropdowns] = useState({
    softwares: [],
    standards: [],
    subjects: [],
    paperTypes: [],
    answerSelectionTypes: []
  });

  const [paperId, setPaperId] = useState(null);

  const [form, setForm] = useState({
    softwareId: "",
    standardId: "",
    subjectId: "",
    paperType: "",
    paperDate: "",
    startTime: "",
    endTime: "",
    marks: "",
    answerType: "",
    supervisor: "",
    instruction: ""
  });
  const loadDropdowns = async (softId, stdId) => {
    const res = await axios.get(
      `${API_BASE}/api/Papers/institute/dropdowns?softwareId=${softId || ""}&standardId=${stdId || ""}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`

        }
      }
    );

   setDropdowns(prev => ({
  softwares: res.data.softwares || prev.softwares,
  standards: res.data.standards || [],
  subjects: res.data.subjects || [],
  paperTypes: res.data.paperTypes || prev.paperTypes,
  answerSelectionTypes: res.data.answerSelectionTypes || prev.answerSelectionTypes
}));
console.log("DROPDOWN RESPONSE:", res.data);


    // auto select standard if software selected
    if (softId && res.data.standards.length === 1) {
      setForm(prev => ({
        ...prev,
        standardId: res.data.standards[0].id
      }));
    }
  };

  useEffect(() => {
    loadDropdowns();
  }, []);

  const calculateEndTime = (start, duration) => {
    if (!start || !duration) return "";

    const [sh, sm] = start.split(":").map(Number);
    const [dh, dm] = duration.split(":").map(Number);

    const date = new Date();
    date.setHours(sh + dh);
    date.setMinutes(sm + dm);

    return date.toTimeString().slice(0, 5);
  };

const handleSoftwareChange = async (e) => {
  const id = e.target.value;

  setForm(prev => ({
    ...prev,
    softwareId: id,
    standardId: "",
    subjectId: ""
  }));
  console.log("Sending:", form.softwareId, id);


  await loadDropdowns(id, null);
};
const handleStandardChange = async (e) => {
  const id = e.target.value;

  setForm(prev => ({
    ...prev,
    standardId: id,
    subjectId: ""
  }));
  

  await loadDropdowns(form.softwareId, id);
};


  const handleChange = (e) => {
    const { name, value } = e.target;

    const updated = { ...form, [name]: value };

    if (name === "startTime" || name === "duration") {
      updated.endTime = calculateEndTime(
        name === "startTime" ? value : form.startTime,
        name === "duration" ? value : form.duration
      );
    }

    setForm(updated);
  };
  return (
    <div className="create-exam-wrapper">
      <div className="page-header">
        <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          परीक्षा व्यवस्थापन   &gt;&gt; <span>परीक्षा तयार करा</span>
        </h3>

        <div className="edit-btnn">

          <button className="btn outlinee" onClick={() => navigate(-1)}>
            रद्द करा
          </button>
          <button
            className="btn primaryy"
            onClick={async () => {
              console.log({
                softwareId: Number(form.softwareId),
                paperType: Number(form.paperType),
                subjectId: form.subjectId ? Number(form.subjectId) : null,
                paperDate: new Date(form.paperDate).toISOString(),
                paperStartTime: form.startTime + ":00",
                duration: form.duration,
                paperEndTime: form.endTime + ":00",
                marks: Number(form.marks),
                answerSelectionType: Number(form.answerType),
              });

              const res = await axios.post(
               `${API_BASE}/api/Papers/institute-admin/create`,
                {
                  softwareId: Number(form.softwareId),
                  paperType: Number(form.paperType),
                  subjectId: form.subjectId ? Number(form.subjectId) : null,
                  paperDate: new Date(form.paperDate).toISOString(),
                  paperStartTime: form.startTime + ":00",
                  paperEndTime: form.endTime + ":00",
                  marks: Number(form.marks),
                  answerSelectionType: Number(form.answerType),
                  paperSupervisor: form.supervisor,
                  instruction: form.instruction
                },
                {
                  headers: {
                   Authorization: `Bearer ${localStorage.getItem("token")}`

                  }
                }
              );

              setPaperId(res.data.paperId);
              setShowPopup(true);
            }}
          >
            पुढे
          </button>

        </div>
      </div>

      {/* Form */}
      <div className="create-exam-form">
        <h2>परीक्षा तयार करा</h2>
        <div className="form-grid">

          <div className="form-group">
            <label>परीक्षेचे नाव</label>
            <select value={form.softwareId} onChange={handleSoftwareChange}>
              <option>परीक्षेचे नाव</option>
              {dropdowns.softwares.map(x => (
                <option key={x.id} value={x.id}>{x.name}</option>
              ))}
            </select>

          </div>

          <div className="form-group">
            <label>परीक्षा प्रकार</label>
            <select name="paperType" value={form.paperType} onChange={handleChange}>
              <option value="">परीक्षा प्रकार</option>
              {dropdowns.paperTypes?.map(x => (
                <option key={x.id} value={x.id}>{x.name}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>इयत्ता</label>
            <select value={form.standardId} onChange={handleStandardChange}>
              <option>इयत्ता</option>
              {dropdowns.standards?.map(x => (
                <option key={x.id} value={x.id}>{x.name}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>विषय</label>
            <select name="subjectId" value={form.subjectId} onChange={handleChange}>
              <option>विषय</option>
              {dropdowns.subjects?.map(x => (
                <option key={x.id} value={x.id}>{x.name}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>परीक्षेची तारीख</label>
            <input type="date" name="paperDate" onChange={handleChange} />
          </div>

          <div className="form-group">
            <label>परीक्षा कालावधी</label>
            <select name="duration" value={form.duration} onChange={handleChange}>
              <option value="">कालावधी निवडा</option>
              <option value="00:30">30 मिनिटे</option>
              <option value="00:45">45 मिनिटे</option>
              <option value="01:00">1 तास</option>
              <option value="01:30">1 तास 30 मिनिटे</option>
              <option value="02:00">2 तास</option>
            </select>
          </div>

          <div className="form-group">
            <label>परीक्षा सुरूवातीची वेळ</label>
            <input type="time" name="startTime" onChange={handleChange} />
          </div>

          <div className="form-group">
            <label>परीक्षा समाप्तीची वेळ</label>
            <input
              type="time"
              name="endTime"
              value={form.endTime || ""}
              readOnly
            />
          </div>

          <div className="form-group">
            <label>गुण</label>
            <input type="text" name="marks" onChange={handleChange} />
          </div>

          <div className="form-group">
            <label>उत्तर निवड प्रकार</label>
            <select name="answerType" value={form.answerType} onChange={handleChange}>
              <option>उत्तर निवड प्रकार</option>
              {dropdowns.answerSelectionTypes?.map(x => (
                <option key={x.id} value={x.id}>{x.name}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>नियुक्त शिक्षक </label>
            <input type="text" name="supervisor" onChange={handleChange} />
          </div>


          <div className="form-group">
            <label>सूचना</label>
            <textarea name="instruction" onChange={handleChange}></textarea>
          </div>
        </div>
      </div>
      {
        showPopup && (
          <div className="exam-popup-overlay">
            <div className="exam-popup-card">
              <div className="exam-popup-icon"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="60" viewBox="0 0 71 71" fill="none">
                <path d="M39.5833 43.75H43.75V31.25H56.25V27.0833H43.75V14.5833H39.5833V27.0833H27.0833V31.25H39.5833V43.75ZM19.2313 58.3333C17.3132 58.3333 15.7118 57.691 14.4271 56.4063C13.1424 55.1215 12.5 53.5201 12.5 51.6021V6.73125C12.5 4.81319 13.1424 3.21181 14.4271 1.92708C15.7118 0.642361 17.3132 0 19.2313 0H64.1021C66.0201 0 67.6215 0.642361 68.9062 1.92708C70.191 3.21181 70.8333 4.81319 70.8333 6.73125V51.6021C70.8333 53.5201 70.191 55.1215 68.9062 56.4063C67.6215 57.691 66.0201 58.3333 64.1021 58.3333H19.2313ZM6.73125 70.8333C4.81319 70.8333 3.21181 70.191 1.92708 68.9062C0.642361 67.6215 0 66.0205 0 64.1031V15.0646H4.16667V64.1031C4.16667 64.7441 4.43368 65.3316 4.96771 65.8656C5.50174 66.3997 6.08958 66.6667 6.73125 66.6667H55.7688V70.8333H6.73125Z" fill="#2563EB" />
              </svg></div>

              <h3>परीक्षा तयार करण्याची पद्धत निवडा</h3>
              <p>आपण कसे पुढे जायचे आहे ते निवडा.</p>

              <div className="exam-popup-actions">
                <button
                  className="exam-popup-btn outline"
                  onClick={() => {
                    setShowPopup(false);
                    navigate(`/dashboard/auto-generate/${paperId}/${form.softwareId}`);
                  }}
                >
                  Auto Generate
                </button>

                <button
                  className="exam-popup-btn primary"
                  onClick={() => {
                    setShowPopup(false);
                    navigate(`/dashboard/addquestion/${paperId}`);
                  }}
                >
                  Add Manually
                </button>
                <button
                  className="exam-popup-btn outline"
                  onClick={() => {
                    setShowPopup(false);
                    navigate(`/dashboard/bydefault/${form.softwareId}/${form.standardId}?targetId=${paperId}`);
                  }}
                >
                  By Default
                </button>
              </div>

              <span className="exam-popup-close" onClick={() => setShowPopup(false)}>
                ✕
              </span>
            </div>
          </div>
        )
      }

    </div >
  );
};

export default CreateExam;
